import { graphql } from "~/gql";

export const CREATE_NOTIFICATION_RULE = graphql(/* GraphQL */ `
  mutation CreateNotificationRule($data: NotificationRuleCreateInput!) {
    createNotificationRule(data: $data) {
      ...NotificationRuleParts
    }
  }
`);
